export default __webpack_public_path__ + "static/img_welfare_1@2x-fd3e7359636bf81c5f2c7a47b5a109bb.jpg";